/*
  Çerez rızası — KVKK uyumlu opt-in.

  ESKİ DAVRANIŞ VE NEDEN DEĞİŞTİ
  Banner yalnızca `!userCanBeTracked` iken açılıyordu. Bu bayrak Shopify'ın
  "bu bölgede rıza zorunlu mu" ayarından geliyor; Türkiye o listede olmadığı için
  hep true dönüyor. Sonuç: banner CANLIDA HİÇ GÖRÜNMÜYORDU ve GA4/Meta/TikTok
  ziyaretçi hiçbir şey seçmeden çalışıyordu. KVKK Çerez Rehberi zorunlu olmayan
  çerezler için açık rıza istiyor.

  ALPINE NEDEN YOK
  Tema Alpine'ı ilk kullanıcı etkileşiminde yüklüyor. Rıza kodu Alpine bileşeni
  olarak kalırsa ziyaretçi sayfaya dokunana kadar hiç çalışmıyor — yani pikseller
  o ana kadar rızasız ateşleniyor. Bu dosya defer ile yükleniyor ve Alpine'ı
  beklemiyor; aç/kapa düz bir CSS sınıfı.

  AKIŞ
  1. Kayıtlı karar yoksa, sayfa açılır açılmaz rıza kategorileri "no"ya çekilir
     -> Shopify pikselleri bloke eder.
  2. Banner `data-gecikme` saniye sonra gösterilir.
  3. Karar hem Shopify'a hem localStorage'a yazılır.

  Kararı localStorage'da da tutuyoruz: Shopify'ın rıza çerezi silinirse
  "hiç sorulmamış" ile "reddetmiş" ayırt edilemiyor, banner her ziyarette geri geliyor.

  Varsayılan engelleme `cerez_varsayilan_red` ayarıyla kapatılabilir — ölçüm kaybı
  sorun olursa deploy beklemeden tema editöründen kapatılabilsin diye.
*/
(function () {
  var KARAR_ANAHTARI = 'alix_cerez_karari';

  function kararOku() {
    try { return localStorage.getItem(KARAR_ANAHTARI); } catch (e) { return null; }
  }
  function kararYaz(deger) {
    try { localStorage.setItem(KARAR_ANAHTARI, deger); } catch (e) {}
  }
  // Boolean kısayolu yalnızca analytics+marketing'i kapsıyor; preferences'ı da
  // açıkça veriyoruz. sale_of_data'ya dokunmuyoruz — o bölgesel bir opt-out konusu.
  function riza(kabul) {
    return { analytics: kabul, marketing: kabul, preferences: kabul };
  }

  function baslat() {
    var banner = document.querySelector('[data-cerez-banner]');
    if (!banner) return;

    var gecikme = parseFloat(banner.getAttribute('data-gecikme') || '0') * 1000;
    var varsayilanRed = banner.getAttribute('data-varsayilan-red') === '1';
    var tasarimModu = banner.hasAttribute('data-tasarim-modu');

    // Arka planda açılan sekmede setTimeout geç ateşleniyor; ziyaretçi bu arada
    // karar verirse gecikmiş zamanlayıcı banner'ı geri açıyordu. Karar verilince iptal.
    var zamanlayici = null;
    var kararVerildi = false;

    function ac() { if (!kararVerildi) banner.classList.add('cerez-banner--acik'); }
    function kapat() { banner.classList.remove('cerez-banner--acik'); }

    // Tema editöründe rıza yazma, sadece göster ki düzenlenebilsin.
    if (tasarimModu) { ac(); return; }

    if (!window.Shopify || !window.Shopify.loadFeatures) return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        var privacy = window.Shopify.customerPrivacy;
        if (!privacy) return;

        var karar = kararOku();

        if (karar === 'kabul' || karar === 'red') {
          // Shopify'ın rıza çerezi silinmiş olabilir; kararı geri uygula.
          privacy.setTrackingConsent(riza(karar === 'kabul'), function () {});
        } else {
          if (varsayilanRed) {
            privacy.setTrackingConsent(riza(false), function () {});
          }
          zamanlayici = setTimeout(ac, gecikme);
        }

        document.dispatchEvent(new CustomEvent('eurus:customer-privacy:loaded'));
      }
    );

    banner.addEventListener('click', function (olay) {
      var dugme = olay.target.closest('[data-cerez]');
      if (!dugme) return;
      var kabul = dugme.getAttribute('data-cerez') === 'kabul';
      kararVerildi = true;
      if (zamanlayici) clearTimeout(zamanlayici);
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(riza(kabul), function () {});
      }
      kararYaz(kabul ? 'kabul' : 'red');
      kapat();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();
